import { RegExps } from '@constants/forms'
import { customizeYup } from '@shared/components/forms/shared/validation/customize-yup'
import { object, string } from 'yup'

import { ApplicationFormDto } from '../../types'

customizeYup()

export const validationSchema = object({
	participant: object().shape<Partial<ApplicationFormDto['participant']>>({
		fullname: string().nullable().required('Укажите фамилию, имя и отчество через пробел'),
		phone: string()
			.matches(RegExps.phone, {
				message: 'Проверьте номер телефона',
			})
			.required('Проверьте номер телефона'),
		email: string()
			.email('Проверьте адрес электронной почты')
			.required('Проверьте адрес электронной почты'),
	}),
	purpose: string().required('Выберите цель кредитования'),
})
